import GloveIconGrey from "./GloveIconGrey";
export default GloveIconGrey;
